import * as React from 'react';
import styled from 'styled-components';
import { CloseIcon, SelectIcon } from './svg';
import Button from '../../mobile-button';

const { useState } = React;

interface IProps {
  onClose: () => void;
  onSubmit: (value: string) => void;
  onChange: (value: string) => void;
  selected: string;
  theme: any;
  text: IObj;
}

const Wrapper = styled.div<{
  bgColor: string;
}>`
  width: 3em;
  background: ${({ bgColor }) => bgColor};
  border-radius: 6px;
  overflow: hidden;
`;
const Title = styled.div<{
  color: string;
  lineColor: string;
}>`
  color: ${({ color }) => color};
  letter-spacing: 0;
  text-align: center;
  line-height: 0.16em;
  padding: 0.16em;
  border-bottom: 1px solid ${({ lineColor }) => lineColor};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Close = styled.a`
  position: absolute;
  right: 0.08em;
  top: 0.08em;
`;
const List = styled.div<{
  color: string;
}>`
  padding: 0 0.16em;
  color: ${({ color }) => color};
  letter-spacing: 0;
`;
const ListItem = styled.div<{
  lineColor: string;
}>`
  padding: 0.12em 0;
  border-bottom: 1px solid ${({ lineColor }) => lineColor};
  display: flex;
  justify-content: space-between;
  :last-child {
    border-bottom: none;
  }
`;

export const Mobile = (props: IProps) => {
  const { onClose, onSubmit, onChange, theme, text, selected } = props;
  const options: IOptionList = text.options;
  const list = options.map((item, index) => {
    const [value, text] = Object.entries<string>(item)[0];
    return (
      <ListItem
        className={`verify-captcha-feedback-item ${
          selected === value
            ? 'verify-captcha-feedback-item-active'
            : 'verify-captcha-feedback-item-inactive'
        }`}
        lineColor={theme.feedbackLineColor}
        onClick={() => onChange(value)}
        key={index}
      >
        <div
          className="verify-captcha-feedback-item--text"
          style={{ wordWrap: 'break-word', fontSize: '0.16em', flex: 1 }}
        >
          {text}
        </div>
        {
          <SelectIcon
            className="verify-captcha-feedback-item--icon"
            style={{ width: '0.18em', height: '0.18em' }}
            selected={selected}
            expected={value}
            onSelectedIconColor={theme.feedbackOnSelectedIconColor}
            unSelectedIconColor={theme.feedbackUnSelectedIconColor}
          />
        }
      </ListItem>
    );
  });
  return (
    <Wrapper
      className="verify-captcha-feedback"
      bgColor={theme.feedbackBgColor}
    >
      <Title
        className="verify-captcha-feedback-title"
        color={theme.feedbackTitleColor}
        lineColor={theme.feedbackLineColor}
      >
        <span
          className="verify-captcha-feedback-title--text"
          style={{ fontSize: '0.16em' }}
        >
          {text.feedback_title}
        </span>
        <Close className="verify-captcha-feedback-close" onClick={onClose}>
          <CloseIcon
            className="verify-captcha-feedback-close--icon"
            color={theme.feedbackCloseIconColor}
            style={{ width: '0.2em', height: '0.2em' }}
          />
        </Close>
      </Title>
      <List
        className="verify-captcha-feedback-list"
        color={theme.feedbackListColor}
      >
        {list}
      </List>
      <Button
        className="verify-captcha-feedback-submit"
        text={text.feedback_sbumit}
        onClick={() => onSubmit(selected)}
        disabled={selected === ''}
        color={theme.feedbackBtnFontColor}
        bgColor={theme.feedbackBtnBgColor}
        opacity={theme.feedbackBtnBgOpacity}
      />
    </Wrapper>
  );
};
